import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StockRoutingModule } from './stock-routing.module';
import { FormsModule } from '@angular/forms';
import { Angular2CountoModule } from '@awaismirza/angular2-counto';
import { FileUploadModule } from 'ng2-file-upload';
import { BsDatepickerConfig, BsDatepickerModule, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'primeng/tooltip';
import { UtilsModule } from '../../shared/utils/utils.module';
import { AppSharedModule } from '../shared/app-shared.module';
import { AppCommonModule } from '../shared/common/app-common.module';
import { SubheaderModule } from '../shared/common/sub-header/subheader.module';
import { AddStocksComponent } from './addStock/addstocks.component';
import { CreateOrEditAddStockComponent } from './addStock/create-or-edit-addstock.component';
import { NgxBootstrapDatePickerConfigService } from '../../assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { StockAdjustmentComponent } from './stockAdjustment/stockadjustments.component';
import { CreateOrEditStockAdjustmentComponent } from './stockAdjustment/create-or-edit-stockadjustment.component';
import { StockTransferComponent } from './stockTransfer/stocktransfer.component';
import { CreateOrEditStockTransferComponent } from './stockTransfer/create-or-edit-stocktransfer.component';
import { StockReceiveComponent } from './stockReceive/stockreceive.component';
import { CreateOrEditStockReceiveComponent } from './stockReceive/create-or-edit-stockreceive.component';
import { StockTakesComponent } from './stockTake/stocktakes.component';
import { CreateOrEditStockTakeModalComponent } from './stockTake/create-or-edit-stocktake-modal.component';
import { CreateOrEditStockItemsComponent } from './stockTake/create-or-edit-stock-items.component';
import { EditStockItemModalComponent } from './stockTake/edit-stock-item-modal.component';
import { CreateOrEditProductionComponent } from './production/create-or-edit-production.component';
import { ProductionsComponent } from './production/productions.component';
import { StockAdjustmentTypesComponent } from './stockAdjustmentType/stockAdjustmentTypes.component';
import { CreateOrEditStockAdjustmentTypeModalComponent } from './stockAdjustmentType/create-or-edit-stockAdjustmentType-modal.component';


@NgModule({
    declarations: [
        AddStocksComponent,
        CreateOrEditAddStockComponent,
        StockAdjustmentComponent,
        CreateOrEditStockAdjustmentComponent,
        StockTransferComponent,
        CreateOrEditStockTransferComponent,
        StockReceiveComponent,
        CreateOrEditStockReceiveComponent,
        StockTakesComponent,
        CreateOrEditStockTakeModalComponent,
        CreateOrEditStockItemsComponent,
        EditStockItemModalComponent,
        CreateOrEditProductionComponent,
        ProductionsComponent,
        StockAdjustmentTypesComponent,
        CreateOrEditStockAdjustmentTypeModalComponent
    ],
  imports: [
      CommonModule,
      FormsModule,
      ModalModule,
      TabsModule,
      TooltipModule,
      AppCommonModule,
      UtilsModule,
      AppSharedModule,
      StockRoutingModule,
      FileUploadModule,
      Angular2CountoModule,
      BsDatepickerModule.forRoot(),
      BsDropdownModule.forRoot(),
      PopoverModule.forRoot(),
      SubheaderModule,
    ],
    providers: [
        { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
        { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
        { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale },
    ],
})
export class StockModule { }
